import React from "react";
import FluidImage from "../../../components/fluidImage";
import Link from "../../../utils/link";
import ReadMoreCross from "./ReadMoreCross";

const BlogPageCard = (props) => {
    return (
        <div className="text-xs lg:text-lg space-y-3 lg:space-y-5 group relative">
            <div className={`overflow-hidden group-hover:opacity-75 transition-opacity duration-300 ${props.mobileLandscape ? `aspect-[335/447]` : `aspect-[335/253]`} lg:aspect-[700/500]`}>
                <FluidImage image={props.image} className='group-hover:scale-[102%] transition-transform duration-500' />
            </div>

            <p className="font-extralight capitalize mobile:hidden">
                {props.date}   {props.tag && (`| ${props.tag}`)}
            </p>
            <h2 className="text-3xl lg:text-53 font-serif font-extralight">{props.title}</h2>

            <div className="!mt-4 lg:!mt-6 flex justify-between">

                <Link to={props.url} className='flex items-center justify-start uppercase space-x-1 lg:space-x-3 font-semibold mobile:text-xs'>
                    <span>Read more</span><ReadMoreCross />
                </Link>
                <span className="lg:hidden font-extralight capitalize">
                {props.date}   {props.tag && (`| ${props.tag}`)}
                </span>
            </div>

            <Link to={props.url} className='absolute inset-0 z-10'>
                <span className="sr-only">Read {props.title}</span>
            </Link>
        </div>
    )
}

export default BlogPageCard;
